class PredictiveSearch extends HTMLFormElement {
  constructor() {
    super();
    this.cachedMap = new Map();
    this.focusElement = this.input;
    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';

    if (this.resetButton) this.resetButton.addEventListener('click', this.clear.bind(this));
    if (this.input) {
      this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 220));
      this.input.addEventListener('focus', this.onFocus.bind(this));
    }

    const isTemplateSearch = this.closest('.template-search');
    if (isTemplateSearch) document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }

  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  onFocus(event) {
    if (!this.closest('.template-search')) return;
    document.body.classList.add('predictive-search-open');
    if (this.getQuery().length < 2) return;
    const url = this.setupURL().toString();
    this.renderSection(url, event);
  }

  getQuery() {
    return this.input ? this.input.value.trim() : '';
  }

  clear(event = null) {
    if (event) event.preventDefault();
    if (this.searchRecommendationEmpty && this.searchContent) this.searchContent.classList.add('hidden');
    if (this.input) {
      this.input.value = '';
      this.input.focus();
    }
    this.removeAttribute('results');
    this.removeAttribute('loading');
    this.removeAttribute('error');
  }

  setupURL() {
    const url = new URL(`${FoxTheme.routes.shop_url}${FoxTheme.routes.predictive_search_url}`);
    url.searchParams.set('q', this.getQuery());
    url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 4);
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this));
    return url;
  }

  onChange() {
    if (this.getQuery().length < 2) {
      this.removeAttribute('results');
      if (this.searchRecommendationEmpty && this.searchContent) this.searchContent.classList.add('hidden');
      return;
    }
    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  renderSection(url) {
    this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
  }

  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.renderSearchResults(responseText);
    this.setAttribute('results', 'true');
  }

  renderSectionFromFetch(url) {
    this.setAttribute('loading', 'true');
    this.removeAttribute('error');
    if (this.resetButton) this.resetButton.classList.add('btn--loading');

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('predictive-search-network');
        return response.text();
      })
      .then((responseText) => {
        this.renderSearchResults(responseText);
        this.cachedMap.set(url, responseText);
        this.setAttribute('results', 'true');
      })
      .catch(() => {
        this.setAttribute('error', 'true');
      })
      .finally(() => {
        this.removeAttribute('loading');
        if (this.resetButton) this.resetButton.classList.remove('btn--loading');
      });
  }

  renderSearchResults(responseText) {
    const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
    const targetElement = document.getElementById(id);
    if (!targetElement) return;

    const parser = new DOMParser();
    const parsedDoc = parser.parseFromString(responseText, 'text/html');
    const contentElement = parsedDoc.getElementById(id);
    if (!contentElement) return;

    if (this.searchContent) this.searchContent.classList.remove('hidden');
    targetElement.innerHTML = contentElement.innerHTML;
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      setTimeout(() => document.body.classList.remove('predictive-search-open'));
    }
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch, { extends: 'form' });
}

class SearchDrawer extends DrawerComponent {
  constructor() {
    super();
  }
  get requiresBodyAppended() {
    return false;
  }
  get input() {
    return this.querySelector('input[type="search"]');
  }
  get focusElement() {
    return this.querySelector('input[type="search"]');
  }
}

if (!customElements.get('search-drawer')) {
  customElements.define('search-drawer', SearchDrawer);
}
